import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  topic: {
    id: 'pib_learn_immerse_title',
  },
  learnablesLabel: {
    id: 'pib_learn_immerse_words',
  },
});

export const en_us = defineMessages({
  cta: {
    id: 'pib_learn_immerse_cta_en',
  },
  text: {
    id: 'pib_header_text_en',
  },
  title: {
    id: 'pib_learn_immerse_subtitle_en',
  },
});

export const es = defineMessages({
  cta: {
    id: 'pib_learn_immerse_cta_es',
  },
  text: {
    id: 'pib_header_text_es',
  },
  title: {
    id: 'pib_learn_immerse_subtitle_es',
  },
});
